import { BrowserRouter, useLocation } from "react-router-dom";
import Routes from "./Routes";
import "./app.css";
import { useEffect } from "react";
import AppStatusBanner from "./Components/AppStatusBanner/AppStatusBanner";
import RenderCompleteListener from "./Components/RenderCompleteListener/RenderCompleteListener";

function App() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <AppStatusBanner />
      <RenderCompleteListener />
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </div>
  );
}

export default App;
